import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AlertState } from './alerts.action';

export const selectAlertState = createFeatureSelector<AlertState>('alert');

export const selectAlerts = createSelector(
    selectAlertState,
    (state: AlertState) => {
        return state.data.idSort.map((id: number) => state.data.idMap[id]);
    }
);
